












import PopupEpisode2 from '@/views/templates/tenugui/PopupEpisode2.vue'

export default
  components: {
    PopupEpisode2
  }

  data: () ->
    message: [
      'CHAORAS&reg; では、使い始めから柔らかな肌触りと吸水性を感じてほしいという想いから、独自の吸水柔軟加工を施しています。 一般的に柔軟加工では油を使うので水をはじいてしまいますが、私たちは昔ながらのツバキ油が吸水を邪魔しない油であることに着目し、三共晒株式会社様と協同でこの加工方法（ab・soft®）を開発しました。'
    ]

  methods: {
    closePopup: () ->
      @$emit('closePopup')
    add_point: (point) ->
      @$emit('addPoint', point)
  }
